var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/core/components/calendar/calendar.html';
var html = "<ng-transclude> </ng-transclude> <div data-ng-model=vm.eventSources id=calendario calendar=calendario ui-calendar=vm.config.calendar></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/core/components/calendar/calendar.html
// module id = 825
// module chunks = 0